export default __webpack_public_path__ + "static/media/login_bg.3a8d1ef0.png";